import React from 'react';

export const Download = () => (
    <svg
        width='25'
        height='24'
        viewBox='0 0 25 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M4.10742 17V19C4.10742 20.1046 5.00285 21 6.10742 21H18.1074C19.212 21 20.1074 20.1046 20.1074 19V17'
            stroke='#38373C'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M5.40032 9.55866C5.79084 9.1816 6.424 9.1816 6.81453 9.55866L11.1074 13.7035V3.96552C11.1074 3.43228 11.5551 3 12.1074 3C12.6597 3 13.1074 3.43228 13.1074 3.96552V13.7035L17.4003 9.55866C17.7908 9.1816 18.424 9.1816 18.8145 9.55866C19.2051 9.93571 19.2051 10.547 18.8145 10.9241L12.8145 16.7172C12.424 17.0943 11.7908 17.0943 11.4003 16.7172L5.40032 10.9241C5.00979 10.547 5.00979 9.93571 5.40032 9.55866Z'
            fill='#38373C'
        />
    </svg>
);
